import { CartItemDTO } from '../cart/cart-item.model';
import { Cart } from '@features/sales/domain/entities/cart/cart.entity';

export enum SplitMode {
  SINGLE_ORDER = 'single_order',
  BY_REDEMPTION = 'by_redemption',
  BY_PRODUCT = 'by_product',
  BY_PERCENTAGE = 'by_percentage',
}

export enum OrderType {
  SALE = 'sale',
  REDEMPTION = 'redemption',
}

export interface OrderDraft {
  type: OrderType;
  items: CartItemDTO[];
}

export interface SplitConfiguration {
  mode: SplitMode;
  contextId?: string;
  productGroups?: Array<{ key: string; itemIds: string[]; }>;
  percentages?: Array<{ key: string; percentage: number; }>;
}

export interface CartSplitPolicy {
  supports(config: SplitConfiguration): boolean;
  partition(cart: Cart, config?: SplitConfiguration): OrderDraft[];
}

